<template>
  <div>
    <div class="container">
      <div class="col-lg-10 mx-auto">
        <h2 class="font-weight-bold text-center mb-4">Perguntas Frequentes</h2>

        <!-- PLATFORM -->
        <section class="mb-5">
          <h3 class="font-weight-bold font-size-medium mb-3 text-underline">Plataforma, Textos e Livros</h3>
          <div class="accordion" role="tablist">
            <div
              no-body
              class="pt-1 pb-2 accordion-item"
              v-for="(question, index) in platform"
              :key="index"
            >
              <div class="accordion-header" v-b-toggle="`accordion-${index}`">
                <h4 class="font-weight-bold text-color2 font-size-medium">{{ question.question }}</h4>
              </div>
              <b-collapse :id="`accordion-${index}`" accordion="my-accordion" role="tabpanel">
                <div>
                  <div v-html="question.answer"></div>
                </div>
              </b-collapse>
              <hr class="h-1 no-border background-color2 mt-4" />
            </div>
          </div>
        </section> <!-- END PLATFORM -->

        <!-- CONTENT -->
        <section class="mb-5">
          <h3 class="font-weight-bold font-size-medium mb-3 text-underline">Conteúdos Pagos e Scriv Wallet</h3>
          <div class="accordion" role="tablist">
            <div
              no-body
              class="pt-1 pb-2 accordion-item"
              v-for="(question, index) in content"
              :key="index"
            >
              <div class="accordion-header" v-b-toggle="`accordion-2-${index}`">
                <h4 class="font-weight-bold text-color2 font-size-medium">{{ question.question }}</h4>
              </div>
              <b-collapse :id="`accordion-2-${index}`" accordion="my-accordion" role="tabpanel">
                <div>
                  <div v-html="question.answer"></div>
                </div>
              </b-collapse>
              <hr class="h-1 no-border background-color2 mt-4" />
            </div>
          </div>
        </section> <!-- END CONTENT -->

        <!-- GROUPS -->
        <section class="mb-5">
          <h3 class="font-weight-bold font-size-medium mb-3 text-underline">Comunidades</h3>
          <div class="accordion" role="tablist">
            <div
              no-body
              class="pt-1 pb-2 accordion-item"
              v-for="(question, index) in groups"
              :key="index"
            >
              <div class="accordion-header" v-b-toggle="`accordion-2-${index}`">
                <h4 class="font-weight-bold text-color2 font-size-medium">{{ question.question }}</h4>
              </div>
              <b-collapse :id="`accordion-2-${index}`" accordion="my-accordion" role="tabpanel">
                <div>
                  <div v-html="question.answer"></div>
                </div>
              </b-collapse>
              <hr class="h-1 no-border background-color2 mt-4" />
            </div>
          </div>
        </section> <!-- END GROPUS -->

        <!-- GROUPS -->
        <section class="mb-5">
          <h3 class="font-weight-bold font-size-medium mb-3 text-underline">Comunidades Pagas</h3>
          <div class="accordion" role="tablist">
            <div
              no-body
              class="pt-1 pb-2 accordion-item"
              v-for="(question, index) in paid_groups"
              :key="index"
            >
              <div class="accordion-header" v-b-toggle="`accordion-2-${index}`">
                <h4 class="font-weight-bold text-color2 font-size-medium">{{ question.question }}</h4>
              </div>
              <b-collapse :id="`accordion-2-${index}`" accordion="my-accordion" role="tabpanel">
                <div>
                  <div v-html="question.answer"></div>
                </div>
              </b-collapse>
              <hr class="h-1 no-border background-color2 mt-4" />
            </div>
          </div>
        </section> <!-- END GROPUS -->

        <!-- DONATIONS -->
        <section class="mb-5">
          <h3 class="font-weight-bold font-size-medium mb-3 text-underline">Cafezinho</h3>
          <div class="accordion" role="tablist">
            <div
              no-body
              class="pt-1 pb-2 accordion-item"
              v-for="(question, index) in donations"
              :key="index"
            >
              <div class="accordion-header" v-b-toggle="`accordion-4-${index}`">
                <h4 class="font-weight-bold text-color2 font-size-medium">{{ question.question }}</h4>
              </div>
              <b-collapse :id="`accordion-4-${index}`" accordion="my-accordion" role="tabpanel">
                <div>
                  <div v-html="question.answer"></div>
                </div>
              </b-collapse>
              <hr class="h-1 no-border background-color2 mt-4" />
            </div>
          </div>
        </section> <!-- END DONATIONS -->

        <!-- POLICIES -->
        <section class="">
          <h3 class="font-weight-bold font-size-medium mb-3 text-underline">Políticas e Regras de Moderação</h3>
          <div class="accordion" role="tablist">
            <div
              no-body
              class="pt-1 pb-2 accordion-item"
              v-for="(question, index) in policies"
              :key="index"
            >
              <div class="accordion-header" v-b-toggle="`accordion-3-${index}`">
                <h4 class="font-weight-bold text-color2 font-size-medium">{{ question.question }}</h4>
              </div>
              <b-collapse :id="`accordion-3-${index}`" accordion="my-accordion" role="tabpanel">
                <div>
                  <div v-html="question.answer"></div>
                </div>
              </b-collapse>
              <hr class="h-1 no-border background-color2 mt-4" />
            </div>
          </div>
        </section> <!-- END POLICIES -->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  metaInfo: {
    title: 'Perguntas Frequentes'
  },
  data () {
    return {
      platform: [
        {
          question: 'O que é a Scriv?',
          answer: '<p>A Scriv é uma comunidade de compartilhamento de textos e livros, conectando autores e leitores brasileiros. Nosso objetivo é democratizar a publicação no Brasil, dando oportunidades aos escritores independentes. Saiba mais clicando <a href="https://scriv.com.br/about" target="_blank" class="link-color2" class="link-color2">aqui</a>.</p>'
        },
        {
          question: 'A Scriv é de alguma empresa?',
          answer: '<p>A Scriv é uma plataforma integralmente desenvolvida e gerida pela <a href="https://kinglystudio.com.br/" target="_blank" class="link-color2">Kingly Studio</a>, software-house fundada em 2015 na cidade de São Paulo.</p>'
        },
        {
          question: 'A plataforma tem algum custo?',
          answer: '<p>Não, a Scriv é e sempre será gratuita para todos os seus autores e autoras, buscando facilitar e incentivar o hábito da escrita. Na modalidade de obras pagas, onde o autor pode decidir cobrar um valor de seus leitores, também não existe nenhum custo para a publicação, mas através da <a href="https://scriv.com.br/scriv-wallet" target="_blank" class="link-color2">Scriv Wallet</a>, gerenciamos as vendas e transações financeiras, retendo apenas uma taxa por obras vendidas.</p>'
        },
        {
          question: 'Como funciona a publicação de textos?',
          answer: `
            <p>Para publicar seu texto na Scriv, basta criar seu perfil na plataforma e clicar em “Escrever” no canto superior direito da página. Em seguida, escolha a opção <a href="https://scriv.com.br/create" target="_blank" class="link-color2">Escrever um texto</a> para começar sua publicação.</p>
            <p>Expresse suas ideias no campo destinado para o texto, podendo este ser salvo para rascunho a qualquer momento (botão no canto superior direito). Se quiser, clicando no botão + que aparece na sua linha atual, você pode utilizar features complementares para sua publicação, como parágrafos, subtítulos, listas, imagens, separadores de linhas e muito mais.</p>
            <p>Ao finalizar seu texto, não se esqueça de:</p>
            <ul class="pl-3">
              <li>Definir o título de sua obra;</li>
              <li>Inserir uma foto de capa para a publicação;</li>
              <li>Definir a opção de visibilidade (público ou privado);</li>
              <li>Definir a data de publicação (agora ou agendado);</li>
              <li>Selecionar uma categoria para a publicação;</li>
              <li>Inserir palavras-chaves como tags do seu texto;</li>
              <li>Definir a habilitação ou não de comentários para a publicação.</li>
            </ul>
            <p>Pronto! Agora basta acompanhar sua publicação na página de <a href="https://scriv.com.br/feed/latest" target="_blank" class="link-color2">Mais Recentes</a> e compartilhar seu texto com seus amigos.</p>
          `
        },
        {
          question: 'Como funciona a publicação de livros?',
          answer: `
            <p>Para publicar seu livro na Scriv, basta criar seu perfil na plataforma e clicar em “Escrever” no canto superior direito da página. Em seguida, escolha a opção <a href="https://scriv.com.br/b/create" target="_blank" class="link-color2">Criar um livro</a> para começar.</p>
            <p>Comece por definir o título e a sinopse de seu livro nos campos destinados. Caso não tenha essas informações definidas ainda, pode preencher com dados temporários, porque você pode editar esses campos a qualquer momento.</p>
            <p>Em seguida, selecione a categoria do seu livro, as configurações de privacidade, o gênero da obra e suas respectivas tags (palavras-chaves para leitores encontrarem seu livro na Scriv).</p>
            <p>Nesse próximo passo, você pode apenas “Criar” o livro para escrever os capítulos depois, mas pode também “Criar e escrever capítulo” para já iniciar sua obra.</p>
            <p>Em cada capítulo, expresse suas ideias no campo destinado para o texto, podendo este ser salvo para rascunho a qualquer momento. Se quiser, clicando no botão + que aparece na sua linha atual, você pode utilizar features complementares para sua publicação, como parágrafos, subtítulos, listas, imagens, separadores de linhas e muito mais.</p>
            <p>Ao finalizar seu capítulo, não esqueça de:</p>
            <ul class="pl-3">
              <li>Definir seu título;</li>
              <li>Inserir uma foto de capa;</li>
              <li>Definir a opção de visibilidade (público ou privado);</li>
              <li>Definir a data de publicação (agora ou agendado);</li>
              <li>Inserir palavras-chaves como tags do seu texto;</li>
              <li>Definir a habilitação ou não de comentários para a publicação.</li>
            </ul>
            <p>Se o livro estiver na opção Público, a publicação do capítulo vai aparecer na página de <a href="https://scriv.com.br/feed/latest" target="_blank" class="link-color2">Mais Recentes</a> para todos da plataforma.</p>
            <p>Caso deseje publicar o livro apenas quando tiver todos os capítulos finalizados, pode deixar os capítulos no modo Privado e torná-los Públicos apenas ao final de sua escrita.</p>
          `
        },
        {
          question: 'A Scriv protege minha obra de possíveis plágios?',
          answer: `
            <p>Sim, a Scriv possui uma ferramenta contra plágios em textos e livros. A plataforma não permite que o texto seja copiado e colado em outro lugar, assim, quando copiado, o trecho fornece o link para o texto.</p>
          `
        },
        {
          question: 'Como funcionam as Tags?',
          answer: `
            <p>As tags utilizadas em todos os textos e livros são importantes para facilitar a busca de conteúdos pelos leitores da Scriv.</p>
            <p>Quando uma tag é inserida em uma publicação, ela é imediatamente vinculada ao nosso sistema de buscas (ícone de lupa no canto superior direito do site). Com isso, qualquer usuário pode encontrar suas palavras-chaves na procura por novos conteúdos na plataforma.</p>
            <p>Por exemplo, os resultados para a tag <a href="https://scriv.com.br/search?term=amor" target="_blank" class="link-color2">“amor”</a> retornam todas as publicações (textos, livros e capítulos) com essa temática.</p>
          `
        },
        {
          question: 'Para que servem as Categorias?',
          answer: `
            <p>As categorias pessoais de cada usuário servem para melhor organizar os conteúdos publicados, assim como para facilitar a navegação de leitores no perfil dos autores.</p>
            <p>As categorias podem ser divididas em tipos de publicação (contos, poemas, críticas, etc.), temáticas e assuntos (amor, terror, romance, etc.) ou qualquer outra divisão que você queira fazer em seus conteúdos.</p>
          `
        },
        {
          question: 'Quais publicações aparecem em Mais Recentes?',
          answer: `
            <p>Na página de <a href="https://scriv.com.br/feed/latest" target="_blank=">Mais Recentes</a> da Scriv, aparecem sempre as últimas publicações feitas na plataforma, independente do autor e da categoria (texto ou capítulo de um livro).</p>
            <p>Entretanto, na seção “Publicações mais recentes” da <a href="https://scriv.com.br/feed/latest" target="_blank" class="link-color2">Página Inicial</a> do site, apresentamos apenas uma publicação por autor, para evitar que uma pessoa detenha o monopólio da seção.</p>
          `
        },
        {
          question: 'Quais publicações aparecem em Populares?',
          answer: `
            <p>Na página de <a href="https://scriv.com.br/feed/trending" target="_blank" class="link-color2">Populares</a> da Scriv, aparecem as publicações com maior engajamento de usuários nos últimos dias, independentemente do autor e da categoria (texto ou capítulo de um livro). O engajamento considera as visualizações, curtidas, comentários e compartilhamentos.</p>
            <p>Entretanto, na seção “Conteúdos em destaque no momento” da Página Inicial do site, apresentamos apenas uma publicação por autor, para evitar que uma pessoa detenha o monopólio da seção.</p>
          `
        }
      ],
      content: [
        {
          question: 'Quais livros eu preciso comprar para ter acesso?',
          answer: '<p>Os livros são pagos apenas se o autor da respectiva obra selecionar essa modalidade de publicação na plataforma. Nesse caso, o valor é definido diretamente pelo autor, e todos os leitores precisarão pagar a quantia especificada para ter acesso digital ao conteúdo. Todas as demais obras da plataforma são gratuitas e de livre acesso por todos.</p>'
        },
        {
          question: 'Posso enviar um livro comprado para outro usuário?',
          answer: '<p>Um livro comprado por um leitor da Scriv pode ser lido apenas por ele mesmo. Caso um outro usuário da plataforma queira acesso ao conteúdo também, ele terá de fazer sua própria compra. Lembrando que, quanto mais leitores individuais comprarem os livros, maior será o incentivo para o autor continuar publicando novos conteúdos.</p>'
        },
        {
          question: 'Como funciona a Scriv Wallet?',
          answer: `
            <p>A <a href="https://scriv.com.br/scriv-wallet" target="_blank" class="link-color2">Scriv Wallet</a> é a carteira digital de todos os Scrivers. Ela é individual, intransferível e vinculada diretamente a cada perfil na plataforma, podendo ser cadastrada uma ou múltiplas contas bancárias e cartões de crédito.</p>
            <p>Através dela, cada leitor pode realizar a compra online de conteúdos de seus autores favoritos e cada autor pode ter controle de todas as receitas de suas obras vendidas.</p>
            <p>No extrato de sua Scriv Wallet, você tem acesso à receita total de seu perfil, assim como a quantidade de vendas realizadas e o saldo disponível para saque. Saiba mais clicando <a href="https://scriv.com.br/scriv-wallet" target="_blank" class="link-color2">aqui</a>.</p>
          `
        },
        {
          question: 'Como são feitas as transações financeiras da Scriv?',
          answer: '<p>Todas as nossas transações financeiras são realizadas pela <a href="https://pagar.me" target="_blank" class="link-color2">Pagar.me</a>, do grupo Stone, mais confiável gateway de pagamentos do Brasil, com padrões mundiais de segurança, criptografia e sistemas de anti-fraude.</p>'
        },
        {
          question: 'Quais as formas de pagamento aceitas na plataforma?',
          answer: '<p>O pagamento pode ser feito via boleto, Pix ou por cartão de crédito (aceitamos todas as principais bandeiras, como: Visa, Mastercard, American Express, Elo, Hipercard, Aura, JCB e Diners).</p>'
        },
        {
          question: 'Por que a Scriv fica com uma porcentagem das vendas?',
          answer: `
            <p>A taxa de vendas retida pela Scriv é utilizada para pagamentos de todos os custos envolvidos na operação, tais como servidores online, estrutura do site e toda a equipe de desenvolvimento, marketing e demais áreas da Scriv.</p>
            <p>Além disso, dentro da nossa taxa já são inclusos os valores de impostos e transações financeiras. Saiba mais sobre nossas taxas clicando <a href="https://scriv.com.br/scriv-wallet" target="_blank" class="link-color2">aqui</a>.</p>
          `
        },
        {
          question: 'Como eu recebo o valor das minhas vendas?',
          answer: '<p>Para receber o valor de suas vendas, basta acessar sua Scriv Wallet, clicando no ícone do seu perfil, no canto superior direito do site. Em seguida, verifique o saldo disponível para saldo e solicite o resgate para sua conta bancária cadastrada.</p>'
        },
        {
          question: 'Em quanto tempo posso resgatar meu saldo?',
          answer: `
            <p>Você pode resgatar seu saldo assim que ele estiver disponível em sua Scriv Wallet, ou seja, assim que os pagamentos realizados pelos leitores forem recebidos pela <a href="https://pagar.me" target="_blank" class="link-color2">Pagar.me</a>.</p>
            <p>Como os pagamentos são feitos via cartão de crédito, o saldo fica disponível no momento em que a fatura do cartão for paga pelo leitor, podendo variar de 20 a 30 dias corridos.</p>
          `
        },
        {
          question: 'Como faço para comprar um livro na Scriv?',
          answer: `
            <p>Para comprar seu livro e garantir acesso digital ao conteúdo, você precisa cadastrar um cartão de crédito em seu perfil, clicando <a href="#" target="_blank" class="link-color2">aqui</a>.</p>
            <p>Em seguida, basta escolher sua obra desejada, clicar em “Comprar livro” e seguir os passos finais indicados pela plataforma.</p>
          `
        },
        {
          question: 'Como funciona a política de devolução de compras?',
          answer: '<p>Para entender a política de devolução da Scriv, clique <a href="https://scriv.com.br/terms-and-conditions" target="_blank" class="link-color2">aqui</a> e acesse a Cláusula Quinta dos nossos Termos de Condições de Uso.</p>'
        },
        {
          question: 'Posso adicionar mais de um cartão de crédito?',
          answer: '<p>Sim, você pode adicionar um ou mais cartões de crédito em sua conta a qualquer momento, basta acessar seu perfil e inserir as informações solicitadas.</p>'
        },
        {
          question: 'Para qual finalidade minha conta bancária é utilizada?',
          answer: '<p>Sua conta bancária é apenas utilizada para você fazer saques de valores da Scriv Wallet para sua conta selecionada. Em nenhuma hipótese faremos transferências automáticas ou solicitaremos qualquer débito de contas cadastradas na Scriv.</p>'
        },
        {
          question: 'Posso cadastrar uma conta bancária de banco digital?',
          answer: '<p>Pode sim, sem problemas! Nosso sistema aceita todos os bancos registrados no BACEN, desde bancos físicos e tradicionais até bancos digitais.</p>'
        },
        {
          question: 'O livro na Scriv precisa ter exclusividade?',
          answer: '<p>Não, o autor é livre para publicar sua obra na Scriv e em outras ferramentas que achar adequado, inclusive o livro em sua versão física. Entretanto, recomendamos concentrar todas as suas vendas pela Scriv, pois o percentual de 70% que fica para o autor é inigualável 😉</p>'
        },
        {
          question: 'Meu livro publicado possui ISBN?',
          answer: '<p>Atualmente, um livro publicado na Scriv não possui o ISBN (International Standard Book Number). Entretanto, estamos trabalhando para, em breve, integrar nossa plataforma com softwares avançados de classificação e identificação de livros.</p>'
        }
      ],
      donations: [
        {
          question: 'O que é o Cafezinho?',
          answer: '<p>O Cafezinho é uma funcionalidade exclusiva da Scriv que permite e incentiva doações individuais de leitores para escritores, de forma a reconhecer seus trabalhos e incentivá-los financeiramente em suas carreiras literárias.</p>'
        },
        {
          question: 'Como habilitar a função Cafezinho em meu perfil?',
          answer: '<p>Basta clicar no ícone de seu perfil, localizado na parte superior direita da página, e ir em <a href="https://scriv.com.br/settings" target="_blank" class="link-color2">Configurações</a> Ao final das opções, você verá o botão “Ativar” na linha do Cafezinho. Lembrando que para a função ser ativada, os dados bancários precisam estar cadastrados.</p>'
        },
        {
          question: 'Como saber quais autores aceitam o Cafezinho?',
          answer: '<p>Já estão com o Cafezinho habilitado todos os autores que tiverem o ícone não apagado de uma xícara de café em seu perfil, ao lado esquerdo do botão Seguir/Seguindo.</p>'
        },
        {
          question: 'Como é realizado o pagamento do Cafezinho?',
          answer: '<p>Todas as transações financeiras desta modalidade são realizadas via Pix, de forma segura e criptografada pela Pagar.me. O valor mínimo é de R$ 5,00 para doações individuais.</p>'
        },
        {
          question: 'Como saber se meu Cafezinho foi pago?',
          answer: '<p>Logo após realizar a doação, você receberá um e-mail de confirmação com todas as informações do Cafezinho pago. Além disso, você pode sempre conferir suas transações na página  <a href="https://scriv.com.br/orders“ target="_blank" class="link-color2">“Minhas Compras”</a>, em seu perfil. </p>'
        },
        {
          question: 'Como resgatar os valores dos Cafezinhos?',
          answer: '<p>Para resgatar os valores recebidos, basta ir na opção <a href="https://scriv.com.br/wallet" target="_blank" class="link-color2">“Minha Carteira”</a> em seu perfil, clicar em Extrato e, em seguida, selecionar a opção “Realizar Saque”.</p>'
        }
      ],
      policies: [
        {
          question: 'Qual a Política de Privacidade da plataforma?',
          answer: '<p>Você pode acessar nossa política completa clicando <a href="https://scriv.com.br/privacy-policy" target="_blank" class="link-color2">aqui.</a></p>'
        },
        {
          question: 'Quais as Regras de Moderação da plataforma?',
          answer: '<p>Você pode acessar nossas regras completas clicando <a href="https://scriv.com.br/moderation-rules" target="_blank" class="link-color2">aqui.</a>.</p>'
        },
        {
          question: 'Quais os Termos de Uso da plataforma?',
          answer: '<p>Ao utilizar a plataforma da Scriv, você declara estar ciente dos Termos e Condições de Uso integralmente descritos <a href="https://scriv.com.br/terms-and-conditions" target="_blank" class="link-color2">aqui.</a>.</p>'
        },
        {
          question: 'A Scriv respeita as diretrizes da nova LGPD?',
          answer: '<p>Com certeza, toda as informações dos nossos usuários estão de acordo com a mais recente alteração na Lei Gerado de Proteção de Dados, conforme a <a href="http://www.planalto.gov.br/ccivil_03/_Ato2019-2022/2019/Lei/L13853.htm" target="_blank" class="link-color2">Lei nº 13.853</a>.</p>'
        }
      ],
      groups: [
        {
          question: 'O que são comunidades?',
          answer: '<p>As comunidades da Scriv servem para que nossos autores tenham a opção de criar grupos de publicações, que podem ser públicos ou privados, e assim direcionar melhor a leitura de seu conteúdo para o público-alvo. Quando uma comunidade é criada, os conteúdos estarão exclusivamente por lá.</p>'
        },
        {
          question: 'Como funcionam as comunidades?',
          answer: '<p>Quando uma comunidade é criada, o autor pode publicar seus textos de forma exclusiva para os membros. Além disso, os próprios membros poderão publicar conteúdo dentro da comunidade, com a moderação do dono da comunidade.</p>'
        },
        {
          question: 'Onde encontro as comunidades?',
          answer: '<p>Na barra lateral esquerda da plataforma, vá em “Comunidades” ou clique <a href="https://scriv.com.br/communities" target="_blank">aqui</a>. Nesta página, estarão dispostas as comunidades existentes na plataforma até o momento, em ordem cronológica.</p>'
        },
        {
          question: 'Como criar minha própria comunidade?',
          answer: '<p>Basta ir para “Comunidades” no menu lateral esquerdo da Scriv e em seguida clicar em “Criar nova”, ou acesse diretamente <a href="https://scriv.com.br/communities/create" target="_blank">aqui</a>. Em seguida, escolha o nome de sua comunidade, personalize sua URL, faça uma breve descrição do grupo, defina o método de moderação e insira as tags relacionadas. Ah, e não esqueça de escolher uma capa bem atrativa para sua comunidade se destacar!</p>'
        },
        {
          question: 'Como adicionar uma publicação na comunidade?',
          answer: '<p>Após finalizada a criação da sua comunidade, a opção de “Criar nova publicação” estará disponível para o autor. Em seguida, basta criar um texto da mesma maneira que uma publicação para o feed da Scriv, selecionando uma capa, adicionando o título, descrição, conteúdo, regras de morações e tags relacionadas.</p>'
        },
        {
          question: 'Como entrar e sair de uma comunidade?',
          answer: '<p>Na página Comunidades, basta clicar na qual gostaria de participar e em seguida confirmar sua intenção no botão “Entrar”, localizado abaixo do nome da comunidade. Você pode sair de uma comunidade a qualquer momento, basta clicar no botão “Sair”, localizado no mesmo lugar abaixo do nome da comunidade.</p>'
        },
        {
          question: 'Onde consigo ver os membros de uma comunidade?',
          answer: '<p>Basta entrar na comunidade desejada e acessar “Membros”, localizado na parte superior da tela. Desta maneira, estarão dispostos todos os usuários que fazem parte desta comunidade.</p>'
        },
        {
          question: 'Como excluir um membro da minha comunidade?',
          answer: '<p>Selecione o botão “Membros” em sua comunidade para acessar a lista completa de membros atuais. Localize o membro que deseja remover e clique no ícone de lixeira localizado à sua direita. Lembrando que apenas o dono da comunidade para remover demais membros.</p>'
        },
        {
          question: 'Onde denunciar uma comunidade?',
          answer: '<p>Entre na comunidade que você deseja denunciar e clique no botão “Denunciar” na parte superior da página. Em seguida, selecione qual opção se encaixa melhor com sua denúncia e, de forma opcional, utilize o campo para adicionar mais informações.</p>'
        },
        {
          question: 'Como deletar uma comunidade?',
          answer: '<p>Caso você seja o administrador, basta entrar na comunidade e selecionar o ícone de lixeira no canto superior direito da página, ao lado do nome de seu usuário. Fique atento pois essa ação é definitiva e irreversível.</p>'
        }
      ],
      paid_groups: [
        {
          question: 'Qual a diferença entre uma comunidade gratuita e uma comunidade paga?',
          answer: '<p>Uma comunidade gratuita não exige nenhum valor ou pagamento para obter acesso, apenas a aprovação do administrador ou moderadores. Por sua vez, uma comunidade paga tem acesso exclusivo para seus assinantes, que irão pagar mensalmente o preço definido pelo dono da comunidade.</p>'
        },
        {
          question: 'Como funciona a definição de preço ao criar a comunidade?',
          answer: '<p>Ao criar ou editar uma comunidade, o criador pode definir o preço que desejar para sua assinatura mensal, ficando com 70% de todas as receitas geradas.</p>'
        },
        {
          question: 'Quais as formas de pagamento de uma assinatura à comunidade?',
          answer: '<p>Os pagamentos são feitos todos digitalmente via Scriv Wallet, tecnologia da Scriv com dados seguros e criptografados, operados pela Pagar.me. As opções de pagamento incluem Pix, Cartão de Crédito e Boleto Bancário.</p>'
        },
        {
          question: 'Como fazer a assinatura de uma comunidade?',
          answer: '<p>Ao entrar na página da comunidade, basta clicar no botão “Assinar” localizado abaixo do título da mesma. A partir disso, defina sua opção de pagamento e finalize o processo financeiro dentro da plataforma.</p>'
        },
        {
          question: 'Onde as transações de assinatura aparecem no meu perfil?',
          answer: '<p>Ao clicar no ícone de seu usuário, localizado no canto superior direito, você verá a opção “Minhas Assinaturas”. Nesta página, estarão dispostas todas as assinaturas vigentes de comunidades.</p>'
        },
        {
          question: 'Como posso cancelar minha assinatura?',
          answer: '<p>O cancelamento da assinatura acontece na área de “Minhas Assinaturas”, a qualquer momento, sem multas ou taxas de cancelamento.</p>'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .accordion-item {
    .accordion-header {
      position: relative;

      &::after {
        position: absolute;
        top: -10px;
        right: 0;
        content: '\f105';
        font-family: 'FontAwesome';
        font-size: 32px;
        color: $color2;
        transition: all 0.2s ease-out;
      }

      &.not-collapsed {
        &::after {
          -moz-transform: rotate(90deg);
          -webkit-transform: rotate(90deg);
          -o-transform: rotate(90deg);
          -ms-transform: rotate(90deg);
          transform: rotate(90deg);
        }
      }
    }

    &:last-child {
      hr {
        display: none;
      }
    }
  }

  .text-underline {
    text-decoration: underline;
  }
</style>
